import React from "react";
import useTransitionStore from "../../../state/transitions";
import useCustomizerStore from "../../../state/customizer";
import { defaultControlAngles } from "../../../util/defaultControlAngles";

const ExteriorBtn = ({ mode, setDelay, Day, toggleAssets }) => {
  const DisplayMode = useTransitionStore((s) => s.DisplayMode);
  const setDisplayMode = useTransitionStore((s) => s.setDisplayMode);
  const setModelInHeader = useTransitionStore((s) => s.setModelInHeader);
  const setCamIndex = useTransitionStore((s) => s.setCamIndex);
  const setDayMode = useTransitionStore((s) => s.setDayMode);
  const HotspotControls = useTransitionStore((s) => s.HotspotControls);
  const setHotspotControls = useTransitionStore((s) => s.setHotspotControls);
  const setAzimuthAndPolarAnglesNeedUpdate = useTransitionStore(
    (s) => s.setAzimuthAndPolarAnglesNeedUpdate
  );
  const setTempAzimuthAndPolarAngles = useTransitionStore(
    (s) => s.setTempAzimuthAndPolarAngles
  );
  const setSuspensionMode = useTransitionStore((s) => s.setSuspensionMode);
  const setSelectedHotspot = useCustomizerStore((s) => s.setSelectedHotspot);
  const setFilterHotspots = useCustomizerStore((s) => s.setFilterHotspots);
  const filterHotspots = useCustomizerStore((s) => s.filterHotspots);

  return (
    <button
      style={{
        background: DisplayMode === "exterior" ? "#EB0A1E" : "#FFF",
        color: DisplayMode === "exterior" ? "#fff" : "#000",
        fontWeight: "600",
      }}
      className="exterior"
      onClick={() => {
        mode.current = "exterior";
        if (Day) setDayMode("day");
        if (DisplayMode == "interior") {
          setTempAzimuthAndPolarAngles(defaultControlAngles);
          setAzimuthAndPolarAnglesNeedUpdate(true);
        }
        setDisplayMode("exterior");
        setModelInHeader(true);
        setDelay(0); //100
        // toggleAssets();
        setCamIndex(1);
        setSelectedHotspot("");
        setSuspensionMode(false);

        if (filterHotspots) setFilterHotspots(false);
        if (HotspotControls) {
          setHotspotControls(false);
          setTempAzimuthAndPolarAngles(defaultControlAngles);
          setAzimuthAndPolarAnglesNeedUpdate(true);
        }
      }}
    >
      Exterior
    </button>
  );
};

export default React.memo(ExteriorBtn);
